export const CATEGORY_OPTIONS = [
  { value: "POLITICA", label: "Política" },
  { value: "MANUAL", label: "Manual" },
  { value: "PROCEDIMIENTO", label: "Procedimiento" },
  { value: "CAPACITACION", label: "Capacitación" },
  { value: "RECETAS_COCINA", label: "Recetas Cocina" },
  { value: "RECETAS_BARRA", label: "Recetas Barra" },
  { value: "COMUNICADO", label: "Comunicado" },
];

export const CATEGORY_LABELS = CATEGORY_OPTIONS.reduce((acc, item) => {
  acc[item.value] = item.label;
  return acc;
}, {});

export function getCategoryLabel(value) {
  return CATEGORY_LABELS[value] || value || "-";
}

export const STATUS_OPTIONS = ["DRAFT", "PUBLISHED", "ARCHIVED"];

export const STATUS_LABELS = {
  DRAFT: "Borrador",
  PUBLISHED: "Publicado",
  ARCHIVED: "Archivado",
};